$shm_hitalama_map_widget_float_posts $shm_hitalama_map_widget_float
	tools_custom /
		<= Font_size_tool $shm_hitalama_map_fontsize
			font_size? <=> font_size? 14
	controls /
		<= Posts $mol_view
			style *
				fontSize <= font_size_px \
			sub /
				^ posts /
					<= Post*0 $mol_card
						content /
							- <= Post_text* $mol_html_view
								html <= post_text* \
							<= Post_dom* null
